import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './Navigation.css';
import Landing from './Landing/Landing';

import WBT from './Platforms/WBT/WBT';
import WBT1 from './Platforms/WBT/WBT1/wbt1';
import Atlas from './components/Atlas';
import About from './components/About';
import Contact from './Landing/Contact';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>

          <Route path="/" element={<Landing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/wbtOLD" element={<WBT />} />

          {/* Platform About Pages */}
          <Route path="/:platformType" element={<About />} />

          {/* Platform Explore Pages - Atlas with platform inside */}
          <Route path="/:platformType/explore" element={<Atlas />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
